var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7295 11.8089L14.6621 0.554177C14.5752 0.472922 14.472 0.408458 14.3584 0.364475C14.2448 0.320491 14.123 0.297852 14 0.297852C13.877 0.297852 13.7552 0.320491 13.6416 0.364475C13.528 0.408458 13.4248 0.472922 13.3379 0.554177L1.27051 11.8089C0.918945 12.137 0.719727 12.5827 0.719727 13.0475C0.719727 14.0128 1.56055 14.7975 2.59473 14.7975H3.86621V22.8284C3.86621 23.3124 4.28516 23.7034 4.80371 23.7034H12.125V17.5784H15.4062V23.7034H23.1963C23.7148 23.7034 24.1338 23.3124 24.1338 22.8284V14.7975H25.4053C25.9033 14.7975 26.3809 14.6143 26.7324 14.2835C27.4619 13.5999 27.4619 12.4925 26.7295 11.8089Z",
    fill: "#10A0B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.7f77f7122f1dcbf11544e936c529834f.svg";
export { ForwardRef as ReactComponent };